import { connectivePluginService } from 'core/di';

export const useConnectivePlugin = () => {
  const initialize = async () => {
    return connectivePluginService.initializePlugin();
  };

  const activate = async (token: Record<string, unknown>) => {
    return connectivePluginService.activate(token);
  };

  const readEIdCertificates = async () => {
    return connectivePluginService.readEIdCertificates();
  };

  const waitForEIdCard = async () => {
    return connectivePluginService.waitForEIdCard();
  };

  const stopWaitingForEIdCard = async () => {
    return connectivePluginService.stopWaitingForEIdCard();
  };

  const computeSignature = async ({
    title,
    message,
    hash,
  }: {
    title: string;
    message: string;
    hash: string;
  }) => {
    return connectivePluginService.computeSignature(title, message, hash);
  };

  return {
    initialize,
    activate,
    readEIdCertificates,
    waitForEIdCard,
    stopWaitingForEIdCard,
    computeSignature,
  };
};
